<template>
  <sign-petition :style="formStyles" />
</template>

<script>
import { mapState } from 'vuex'
import SignPetition from './sign-petition'
import TopLevelMixin from './top-level-mixin'

const STYLES_KEYS = ['bg_color', 'text_color']

export default {
  components: { SignPetition },

  mixins: [ TopLevelMixin ],

  computed: {
    ...mapState(['styles']),

    formStyles() {
      let output = ''
      for (const key of STYLES_KEYS) {
        if (this.styles[key]) {
          switch (key) {
          case 'bg_color':
            output += `background: ${this.styles[key]};`
            break
          case 'text_color':
            output += `color: ${this.styles[key]};`
            break
          default:
            throw `invalid key ${key}`
          }
        }
      }
      return output
    }
  }
}
</script>
